import { useEffect } from 'react';
import { useUnreadMessages } from './useUnreadMessages';

/**
 * Sync the unread conversations count to the OS-level app badge
 * (Windows taskbar, macOS dock, mobile home screen).
 *
 * Uses the Badging API: https://developer.mozilla.org/en-US/docs/Web/API/Badging_API
 * Silently no-ops on browsers that don't support it (Firefox).
 */
export function useAppBadge() {
  const { totalUnreadConversations } = useUnreadMessages();

  useEffect(() => {
    if (typeof navigator === 'undefined') return;

    // Badging API is under navigator — check before calling
    const nav = navigator as any;

    if (totalUnreadConversations > 0 && typeof nav.setAppBadge === 'function') {
      nav.setAppBadge(totalUnreadConversations).catch(() => {
        // Some browsers require the app to be installed; fail silently
      });
    } else if (typeof nav.clearAppBadge === 'function') {
      nav.clearAppBadge().catch(() => {});
    }
  }, [totalUnreadConversations]);
}
